import { Manhattan } from "./maps/manhattan";

export class Junction {

    public static readonly JUNCTION_SIZE = 2;
    public static readonly ROAD_WIDTH = 5;
    
    private static readonly ROAD_COLOUR = '#222222';

    id: number;
    x: number;
    y: number;
    connectedTo: Array<Junction>;

    constructor(id: number, x: number, y: number, connectedTo: Array<Junction>) {
        this.id = id;
        this.x = x;
        this.y = y;
        this.connectedTo = connectedTo;

        this.drawJunction();

        connectedTo.forEach((junctionConnectedTo: Junction) => {
            this.drawRoad(junctionConnectedTo);
        });
    }

    drawJunction() {
        let element: SVGCircleElement = document.createElementNS('http://www.w3.org/2000/svg', 'circle');

        element.setAttribute('cx', this.x.toString());
        element.setAttribute('cy', this.y.toString());
        element.setAttribute('r', Junction.JUNCTION_SIZE.toString());
        element.style.borderRadius = '100px';

        document.getElementById('mapWrapper')!.append(element);
    }

    drawRoad(otherJunction: Junction) {
        let roadLineElem = document.createElementNS('http://www.w3.org/2000/svg', 'line');

        roadLineElem.setAttribute('x1', (this.x).toString());
        roadLineElem.setAttribute('y1', (this.y).toString());
        roadLineElem.setAttribute('x2', (otherJunction.x).toString());
        roadLineElem.setAttribute('y2', (otherJunction.y).toString());
        roadLineElem.setAttribute('stroke-width', Junction.ROAD_WIDTH.toString());
        roadLineElem.setAttribute('stroke', Junction.ROAD_COLOUR);

        document.getElementById('mapWrapper')!.append(roadLineElem);
    }

    getRandomConnectedJunction(excludedJunction: Junction|undefined = undefined): Junction {
        //@todo: redo
        let nextJunction: Junction = this;
        let attemptsToFindJunction = 0;

        let thisClass = this;
        while(nextJunction == this || (excludedJunction == nextJunction && thisClass.connectedTo.length > 1) && attemptsToFindJunction < 10) {
            nextJunction = thisClass.connectedTo[Math.floor(Math.random() * thisClass.connectedTo.length)];
            attemptsToFindJunction++;
        }

        return nextJunction;
    }


}